export default {
  // 获取个人音频信息
  getUserAudio(id) {
    return this.http(
      'ExerciseCheck',
      'get',
      `/api/v1/audio/courses/${id}.json`
    );
  },

  // 获取音频列表
  getAudioList(courseId) {
    return this.http(
      'ExerciseCheck',
      'get',
      `/api/v1/audio/courses/${courseId}/items.json`
    );
  },

  // 获取音频详情信息
  getCourseInfo(courseId, id) {
    return this.http(
      'ExerciseCheck',
      'get',
      `/api/v1/audio/courses/${courseId}/items/${id}`
    );
  },

  // 音频打卡
  audioCheckIn(params) {
    return this.http(
      'ExerciseCheck',
      'post',
      '/api/v1/audio/user_audios',
      params
    );
  }
};
